import { createEpic } from "../helpers";

import {
	getAssetsListAsyncAction,
	postAssetAsyncAction,
	updateAssetAsyncAction,
} from "./assetsActions";

export const getAssetsListEpic = createEpic(
	getAssetsListAsyncAction,
	"assets",
	"getAssetsList",
	true
);

export const postAssetEpic = createEpic(
	postAssetAsyncAction,
	"assets",
	"postAsset",
	true
);

export const updateAssetEpic = createEpic(
	updateAssetAsyncAction,
	"assets",
	"updateAsset",
	true
);
